<template>
  <div class="component-content sub-content">
    <!-- <div class="list-title">
      <el-radio-group size="mini" v-model="relateType">
        <el-radio-button label="0">我使用的</el-radio-button>
        <el-radio-button label="1">我负责的</el-radio-button>
      </el-radio-group>
    </div> -->
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <!-- <el-table-column type="selection" width="25px">
      </el-table-column> -->
      <el-table-column prop="number" label="资产编号" width="160px">
      </el-table-column>
      <el-table-column label="资产名称">
        <template slot-scope="scope">
          {{ scope.row.name }}
          <span>
            <el-tag type="success" size="mini" v-if="scope.row.cwStatus==1">财务已确认</el-tag>
            <el-tag type="danger" size="mini" v-else>财务未确认</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="attribute.name" label="资产属性" width="90px">
      </el-table-column>
      <el-table-column prop="spec" label="规格型号" width="140px">
      </el-table-column>
      <el-table-column prop="price" label="购置金额" width="90px" align="center">
      </el-table-column>
      <el-table-column prop="purchaseTime" label="购置时间" width="80px">
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom">
            <i @click="assetDetail(scope.row)" class="iconfont icon-157 meeting-btn-icon"></i>
          </el-tooltip>
          <el-tooltip class="item" v-if="scope.row.cwStatus==0 || scope.row.cwStatus==-1" effect="dark"
            content="确认该资产财务信息" placement="bottom">
            <i @click="showAssetFinanceInfo(scope.row)" class="iconfont icon-duigou meeting-btn-icon mbi-edit"></i>
          </el-tooltip>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <asset-detail></asset-detail>

    <!-- 财务确认弹窗 -->
    <el-dialog title="资产入库财务确认" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" :model="form" label-width="90px" class="page--form">

        <el-form-item label="购置金额" class="required-label">
          <el-input placeholder="购置金额（单价）(元)" type="number" size="small" v-model="form.price"></el-input>
        </el-form-item>
        <el-form-item label="入账时间" prop="startTime">
          <el-date-picker class="full" size="small" value-format="yyyy-MM-dd" v-model="form.time" type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="assetConfirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'

  import AssetDetail from './assetDetail'
  export default {
    components: {
      UserInfo,
      AssetDetail
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 财务确认
        dialogVisible: false,
        form: {
          type: 2,
          assetId: '',
          price: '',
          time: ''
        },

        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表类型 0：我使用的  1：我负责的
        relateType: "0",
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      if (!this.userData) {
        return false
      }

      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      this.getLists()
    },
    methods: {
      // 资产财务确认
      assetConfirm() {
        if (!this.form.price) {
          this.$message.error("请填写资产金额")
          return
        }
        if (!this.form.time) {
          this.$message.error("请填写资产财务入账时间")
          return
        }
        ajax.post('/asset/confirm', this.form, (res) => {
          this.dialogVisible = false
          this.getLists()
        })
      },
      // 显示财务相关的确认细节 金额/入账时间
      showAssetFinanceInfo(row) {
        this.form = {
          type: 2,
          assetId: row.id,
          price: row.price,
          time: row.rzTime
        }
        this.dialogVisible = true
      },

      // 显示详情
      assetDetail(row) {
        let assetChangeDetail = {
          status: false,
          data: {}
        }
        this.$store.commit('set_assetChangeDetail', assetChangeDetail)

        let assetDetail = {
          status: true,
          data: row
        }
        this.$store.commit('set_assetDetail', assetDetail)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/asset/relate/me', {
          type: 2
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'relateType'() {
        this.getLists()
        let assetDetail = {
          status: false,
          data: ''
        }
        this.$store.commit('set_assetDetail', assetDetail)
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/myFinanceList.vue